var exports = {
  "kL": "ChannelPermissionsTab.module__container___NDREeW",
  "Ut": "ChannelPermissionsTab.module__syncBanner___NDREeW",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___NDREeW",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___NDREeW",
  "Vg": "ChannelPermissionsTab.module__grid___NDREeW",
  "s4": "ChannelPermissionsTab.module__leftTitle___NDREeW",
  "pG": "ChannelPermissionsTab.module__right___NDREeW",
  "ze": "ChannelPermissionsTab.module__rightScroller___NDREeW",
  "CI": "ChannelPermissionsTab.module__sectionRow___NDREeW",
  "bV": "ChannelPermissionsTab.module__sectionHeader___NDREeW",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___NDREeW",
  "bQ": "ChannelPermissionsTab.module__subtleText___NDREeW",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___NDREeW",
  "mA": "ChannelPermissionsTab.module__permHelp___NDREeW",
  "p$": "ChannelPermissionsTab.module__emptyState___NDREeW",
  "rV": "ChannelPermissionsTab.module__overwriteItem___NDREeW",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___NDREeW",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___NDREeW",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___NDREeW",
  "m4": "ChannelPermissionsTab.module__roleDot___NDREeW",
  "l": "ChannelPermissionsTab.module__overwriteName___NDREeW",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___NDREeW",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___NDREeW",
  "sN": "ChannelPermissionsTab.module__layoutButtons___NDREeW",
  "Zh": "ChannelPermissionsTab.module__layoutButton___NDREeW",
  "HU": "ChannelPermissionsTab.module__permCategories___NDREeW",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___NDREeW",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___NDREeW",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___NDREeW",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___NDREeW",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___NDREeW",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___NDREeW",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___NDREeW",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___NDREeW",
};

module.exports = exports;
